const degrees_to_cardinal = (d) => {
  const dirs = [
    'N',
    'NNE',
    'NE',
    'ENE',
    'E',
    'ESE',
    'SE',
    'SSE',
    'S',
    'SSW',
    'SW',
    'WSW',
    'W',
    'WNW',
    'NW',
    'NNW',
  ];
  const ix = Math.floor((d + 11.25) / 22.5);
  return dirs[ix % 16];
};

export { degrees_to_cardinal };
